import React, { useEffect, useState } from 'react';
import { Nav, TabContainer, TabContent, TabPane } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

import CustomTips from 'components/base/CustomTips';
import CustomViewer from 'components/base/CustomViewer';

import './CustomListComponent.scss';

function CustomListComponent(props) {
  const breadcrumb = props.breadcrumb;
  const caution = props.caution;
  const buttons = props.buttons || [];
  const renderTabsRight = props.renderTabsRight;
  const renderCompare = props.renderCompare;
  const tabs = props.tabs || [];
  const title = props.title || '';
  const defaultActiveKey = props.defaultActiveKey || '';
  const onTabChange = props.onTabChange || (() => {});
  const [activeTab, setActiveTab] = useState();
  const hideTab = props.hideTab;
  const location = useLocation();

  // const { user } = useSelector((state) => ({
  //   user: state.users,
  // }));

  useEffect(() => {
    console.log('location list change');
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    setActiveTab(defaultActiveKey);
  }, [defaultActiveKey]);
  const getCaution = () => {
    return caution ? (
      <CustomTips detail={caution.detail} renderExtra={renderCompare}>
        {caution.titleIsHtml ? (
          <CustomViewer
            className="list-section-container-header-title"
            initValue={caution.title}
          />
        ) : (
          <label className="list-section-container-header-title">
            {caution.title}
          </label>
        )}
      </CustomTips>
    ) : null;
  };

  const getTabs = () => {
    return (
      <TabContainer
        activeKey={activeTab || tabs[0]?.name}
        className={`list-section-container-content-bar`}
        onSelect={(key) => {
          onTabChange(key);
        }}
      >
        <Nav className="list-section-container-content-bar nav nav-tabs">
          {tabs.map((tab) => (
            <Nav.Link key={tab.name} className="nav-item" eventKey={tab.name}>
              {tab.name}
            </Nav.Link>
          ))}

          {renderTabsRight && renderTabsRight()}
        </Nav>
        <TabContent>
          {tabs.map((tab, index) => (
            <TabPane eventKey={tab.name} key={index}>
              {tab.content}
            </TabPane>
          ))}
        </TabContent>
      </TabContainer>
    );
  };

  // if (!checkHasPermission(user)) {
  //   history.push({ pathname: '/login', state: { isLogout: true } });
  //   return;
  // }

  return (
    <>
      <div
        className={`list-section-container-header ${
          hideTab ? 'list-section-container-header-bottom' : ''
        }`}
      >
        {breadcrumb}
        <div className="list-section-container-button-and-title">
          <div className="list-section-container-header-left">
            {title ? (
              <label className="list-section-container-header-title">
                {title}
              </label>
            ) : null}
            {getCaution()}
          </div>
          <div className="list-section-container-header-buttons">
            {buttons.map((item, index) => (
              <div key={index}>{item}</div>
            ))}
          </div>
        </div>
      </div>
      {hideTab ? tabs.map((item) => item.content) : getTabs()}
    </>
  );
}

export default CustomListComponent;
